import React from 'react';
import { Modal, Box, Typography, Button, Alert } from '@mui/material';

interface Props {
  open: boolean;
  handleClose: () => void;
  onSuccess: () => void;
}

const ProviderDeactivationModal: React.FC<Props> = ({
  open, handleClose, onSuccess
}) => {
  const handleSubmit = async () => {
    try {
      onSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 400,
        bgcolor: 'background.paper',
        p: 4
      }}>
        <Typography id="modal-title" variant="h6" component="h2">
          Deactivate Provider
        </Typography>
        <Box id="modal-description" sx={{ mt: 2 }}>
          <Typography variant='body1'></Typography>
          <Alert severity="warning" sx={{ mb: 2 }}>
            <Typography variant="body2">
              Are you sure you want to deactivate this provider ?
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              This action will cancel all future shifts.
            </Typography>
          </Alert>
        </Box>

        <Box justifySelf='flex-end'>
          <Button
            onClick={() => {
              handleClose();
            }}
            sx={{ mr: 4 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            data-testid="deactivate-provider-button"
            size='large'
            onClick={handleSubmit}
          >
            Deactivate
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ProviderDeactivationModal;

